export default "__VITE_ASSET__phDd0jdv__"